const info = {
    $schema: '../assetlist.schema.json',
    chain_name: 'starname',
    assets: [{
            description: 'IOV coin is the token for the Starname (IOV) Asset Name Service',
            denom_units: [{
                    denom: 'uiov',
                    exponent: 0
                }, {
                    denom: 'iov',
                    exponent: 6
                }],
            base: 'uiov',
            name: 'Starname',
            display: 'iov',
            symbol: 'IOV',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.svg'
            },
            coingecko_id: 'starname',
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.svg',
                    theme: {
                        primary_color_hex: '#5c64b4'
                    }
                }],
            socials: {
                website: 'https://app.starname.me/',
                twitter: 'https://twitter.com/starname_me'
            },
            type_asset: 'sdk.coin'
        }]
};
export default info;
